import { render, staticRenderFns } from "./vesselTrackingHistory.vue?vue&type=template&id=5255505f&scoped=true"
import script from "./vesselTrackingHistory.vue?vue&type=script&lang=js"
export * from "./vesselTrackingHistory.vue?vue&type=script&lang=js"
import style0 from "./vesselTrackingHistory.vue?vue&type=style&index=0&id=5255505f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255505f",
  null
  
)

export default component.exports